<!-- 注册 -->
<template>
  <div class="register">
    <div class="register-container">
      <div class="register-head">
        <img :src="logo"
             alt="再来人logo">
        <p class="register-head-title">Mentor Service Platform</p>
      </div>
      <ul class="register-intro">
        <li>
          <h1>About us</h1>
          <div>ZLR Valeon is dedicated to empowering Chinese youth to achieve their potential. We connect top Chinese undergraduates with mentors from the world's leading institutions. With more than a thousand mentors, they come from top schools around the world such as Harvard, MIT, Stanford, etc. Valeon was founded by Oxford graduates Alan and Vits. Our advisory board includes the former Executive Director at Harvard, Director at Stanford and the Head of Education for EMEA/Asia for Apple Inc.</div>
        </li>
        <li>
          <h1>Job description</h1>
          <div>
            <a @click="handleAlert()">School Mentor / Career Mentor</a>
          </div>
        </li>
      </ul>
      <div class="register-content">
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate"
              label-position="top">
          <Row :gutter="16">
            <Col :xl="12"
                 :sm="24">
            <FormItem label="First Name"
                      prop="firstName">
              <Input v-model.trim="formValidate.firstName"
                     placeholder="e.g. John"
                     clearable></Input>
            </FormItem>
            </Col>
            <Col :xl="12"
                 :sm="24">
            <FormItem label="Last Name"
                      prop="lastName">
              <Input v-model.trim="formValidate.lastName"
                     placeholder="e.g. Smith"
                     clearable></Input>
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :xl="12"
                 :sm="24">
            <FormItem label="WeChat ID"
                      prop="weChat">
              <Input v-model.trim="formValidate.weChat"
                     placeholder="(If you don't have WeChat, fill in N/A)"
                     clearable></Input>
            </FormItem>
            </Col>
            <Col :xl="12"
                 :sm="24">
            <FormItem label="Email"
                      prop="email">
              <Input v-model.trim="formValidate.email"
                     placeholder="e.g. you@domain.com"
                     clearable></Input>
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :xl="12"
                 :sm="24">
            <FormItem label="Graduate University"
                      prop="univer">
              <Input v-model.trim="formValidate.univer"
                     placeholder="e.g. Harvard University"
                     clearable></Input>
            </FormItem>
            </Col>
            <Col :xl="12"
                 :sm="24">
            <FormItem label="Field of study"
                      prop="field">
              <!-- <Select v-model="formValidate.field"
                      placeholder="select your field"
                      clearable
                      :filterable=true>
                <Option v-for="(item,index) in field"
                        :value="item"
                        :key="index">{{item}}</Option>
              </Select> -->
              <Cascader :data="specialityList" v-model="formValidate.field"></Cascader>
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :xl="12"
                 :sm="24">
            <FormItem label="Degree"
                      prop="degree">
              <Select v-model="formValidate.degree"
                      placeholder="select your highest level degree obtained">
                <Option v-for="item in degree"
                        :key="item.value"
                        :value="item.value">{{item.title}}</Option>
              </Select>
            </FormItem>
            </Col>
            <Col :xl="12"
                 :sm="24">
            <FormItem label="CV (If unable to upload, please send to mentorhelp@valeon.com)"
                      prop="cv">
              <div class="register-cv">
                <div v-show="cvName">
                  <span class="register-cv-name">{{cvName}}</span>
                  <Icon type="ios-close-circle"
                        size="16"
                        class="register-cv-del"
                        @click="delCVhandle" />
                </div>
                <span class="register-cv-upload"
                      @click="uploadHandle()"
                      v-show="!cvName">
                  Upload
                </span>
              </div>
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :xl="24"
                 :sm="24">
            <FormItem label="Do you have any mentoring experiences cooperated with another study-abroad company?"
                      prop="hasMentorExperience">
              <RadioGroup v-model="formValidate.hasMentorExperience"
                          @on-change="changeHasMentorExperience">
                <Radio label="0">No</Radio>
                <Radio label="1">Yes</Radio>
              </RadioGroup>
              <Input v-model="formValidate.mentorExperiences"
                     clearable
                     placeholder="Please enter details"
                     type="textarea"
                     :rows="4"
                     class="input-textarea"
                     v-if="formValidate.hasMentorExperience === '1'"></Input>
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :xl="24"
                 :sm="24">
              <FormItem
                      label="How did you hear about us? If referred by a specific person, please specify the name of referrer/ others."
                      prop="hearByType"
              >
                <Select
                        v-model="formValidate.hearByType"
                        placeholder="select one"
                >
                  <Option
                          v-for="item in referrerSource"
                          :value="item.value"
                          :key="item.value"
                  >{{ item.title }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem label="" prop="hearBy" class="dis-40">
                <Input
                        v-model="formValidate.hearBy"
                        placeholder="e.g. Vits Voronkov, I saw it in 2018 Havard alumni wechat group/ I was a ZLR 18/19 mentee"
                        type="textarea"
                        :rows="6"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col :xl="12"
                 :sm="24">
            <FormItem label="Password"
                      prop="password">
              <Input v-model="formValidate.password"
                     type="password"
                     clearable
                     placeholder="Password will be used later to complete application "></Input>
            </FormItem>
            </Col>
            <Col :xl="12"
                 :sm="24">
            <FormItem label="Re-enter password"
                      prop="againPwd">
              <Input v-model="formValidate.againPwd"
                     type="password"
                     clearable></Input>
            </FormItem>
            </Col>
          </Row>
        </Form>
        <div class="register-goSign">
          <span @click="$router.push({name: 'login'})">Already have an account? Sign in here.</span>
        </div>
        <div class="register-btn">
          <Button class="zlr-btn-primary"
                  @click="signHandle"
                  :loading="isSub">Apply</Button>
        </div>
        <div class="zlr-relate relate-top">
          <h3>ZLR Valeon's community</h3>
          <h4>In order to expand ZLR Valeon's community, we expect all mentors to contribute something to ZLR Valeon's community. There are 4 options for community contribution:</h4>
          <p>1. One hour online info session</p>
          <p>2. 30-60 minutes Master Class (Sharing a concept or knowledge to the general public in your specific domain, making it easy to understand, e.g. What is Machine Learning?)</p>
          <p>3. One Wechat Article (Share your study abroad experience in text)</p>
          <p>4. Other ways you can contribute to the community (Please specify & welcome to be creative! :) )</p>
        </div>
        <div class="zlr-relate">
          <h3>Wechat</h3>
          <p>If you have Wechat, please add the mentor department Wechat below. If you’ve passed the resume screening round, we’ll contact you on Wechat (or via e-mail if you don’t have Wechat) to schedule the time for an online interview. P.S. Please add “导师申请-姓名-学校-科系-master/phd)” as the comment when adding our Wechat, thanks!</p>
          <img :src="MentorWeChatQR"
               alt="再来人二维码" />
        </div>
        <div class="register-copyright" v-html="copyright">
        </div>
      </div>
    </div>
    <zlr-modal v-model="descModal">
      <div class="register-desc">
        <h1>{{smcmDesc.title}}</h1>
        <ul>
          <li v-for="(item, index) in smcmDesc.content"
              :key="index">
            <h2>{{item.title}}</h2>
            <div v-html="item.detail">
              {{item.detail}}
            </div>
          </li>
        </ul>
        <div class="register-desc-btn">
          <Button class="zlr-btn-default"
                  @click="descModal = false">Close</Button>
        </div>
      </div>
    </zlr-modal>
    <apply-upload v-model="cvModal"
                  ref="cvModal"
                  :path="`register/smcm/${new Date().getTime()}`"
                  @up-success="cvSucHandle"></apply-upload>
  </div>
</template>

<script>
import { field, degree, referrerSource } from '@/constant/mentor'
import { copyright, promptSelect, promptInput } from '@/constant'

import { validateEmail } from '@/libs/validator'
// api
import { registerSmCm, mentorMajor } from '@/api/talents'
// less
import './index.less'
// images
import logo from '@/assets/Logo.svg'
// images
import MentorWeChatQR from '@/assets/Mentor_WeChat_QR.svg'
// components
import ZlrModal from '_c/modal/modal'
import ApplyUpload from './components/upload'
import { mapActions } from 'vuex'
export default {
  name: 'register-smcm',
  components: {
    ZlrModal,
    ApplyUpload
  },
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password'))
      } else if (value !== this.formValidate.password) {
        callback(new Error('The entered passwords are inconsistent'))
      } else {
        callback()
      }
    }
    return {
      specialityList: [],
      logo,
      MentorWeChatQR,
      referrerSource,
      field,
      copyright,
      degree,
      formValidate: {},
      isSub: false,
      cvName: '',
      cvModal: false,
      ruleValidate: {
        firstName: [{ required: true, message: 'Please enter your first name' }],
        lastName: [{ required: true, message: 'Please enter your last name' }],
        weChat: [{ required: true, message: 'Please enter your weChat id' }],
        email: [{ required: true, message: 'Please enter your email' }, { validator: validateEmail }],
        univer: [{ required: true, message: 'Please enter your current graduate university' }],
        field: [{ required: true, message: 'Please enter your field of study' }],
        degree: [{ required: true, message: promptSelect }],
        password: [{ required: true, message: 'Please enter your password' }],
        cv: [{ required: true, message: 'Required, but if unable to upload, please send to mentorhelp@zlrvaleon.com' }],
        againPwd: [{ required: true, message: 'Please enter your password' }, { validator: validatePass }],
        hasMentorExperience: [{ required: true, message: promptSelect }],
        hearByType: [{ required: true, message: promptSelect }],
        hearBy: [{ required: true, message: promptInput }]
      },
      descModal: false,
      smcmDesc: {
        title: 'School Mentor / Career Mentor',
        content: [
          {
            title: 'Basic Responsibilities',
            detail: `Help mentees with graduate study applications and career guidance in your field<br/>
Help with application essays (focusing on strategy, content and style) as well as give mentees advice on graduate study, careers etc. through video conference.<br/>
The busiest time of year for School Mentor/ Career Mentor is generally around graduate application season (Sep-Feb), however work may be available throughout the year.
`
          },
          {
            title: 'Benefits',
            detail: `Get remunerated up to US$90/hr for helping a bright young person<br/>
Join our Mentor Network of talented individuals across industries (we already have 50+ Rhodes Scholars in our community)<br/>
Receive exclusive job opportunities as part of our Mentor Network (past include executive assistant roles for CEOs, roles at UNDP, roles with the Schwarzman Scholar program, etc.)`
          },
          {
            title: 'Requirements',
            detail: `Previously studied at or currently completing top graduate program/university<br/>
Positive and interested in positively impacting a bright young person at a critical juncture<br/>
Reliable and responsible in honoring commitments`
          }
        ]
      }
    }
  },
  computed: {},
  mounted () {
    mentorMajor().then(res => {
      this.formatMajorName(res.data.model)
      this.specialityList = res.data.model
    })
  },
  methods: {
    ...mapActions(['handleLogin']),
    formatMajorName (obj) {
      for (let i of obj) {
        i.label = i.majorName
        i.value = i.majorName
        if (i.children && i.children.length) {
          this.formatMajorName(i.children)
        }
      }
    },
    // 注册
    signHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.isSub = true
          let data = Object.assign({}, this.formValidate)
          // delete data.field
          data.firstMajor = data.field[0]
          data.field = data.field[1]
          registerSmCm(data).then(res => {
            if (res.code === 0) {
              this.$zlr_message('Successfully Applied', 'success')
              this.mockLoginHandle(data)
            } else {
              this.$zlr_message(res.message, 'error')
            }
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    mockLoginHandle (data) {
      this.handleLogin({
        email: data.email,
        password: data.password
      }).then(() => {
        this.$router.push({
          name: 'apply-select'
        })
      })
    },
    // 介绍弹窗
    handleAlert (type) {
      this.descModal = true
    },
    uploadHandle () {
      this.$refs['cvModal'].showHandle()
    },
    // cv
    cvSucHandle (data) {
      this.$set(this.formValidate, 'cv', data.path)
      this.cvName = data.name
    },
    // 删除cv
    delCVhandle () {
      this.cvSucHandle({
        path: '',
        name: ''
      })
    },
    // 选择是否有经验
    changeHasMentorExperience (value) {
      if (value === '0') {
        this.formValidate.mentorExperiences = ''
      }
    }
  }
}
</script>
<style lang='less' scoped>
</style>
